import { useEffect, useCallback, useState } from 'react';

const safeDocument = typeof document !== 'undefined' ? document : undefined;
const safeWindow = typeof window !== 'undefined' ? window : undefined;

const ThemePreference = () => {
    const [currentTheme, setCurrentTheme] = useState<'light' | 'dark'>(() => {
        const userPrefersDark = safeWindow?.matchMedia('(prefers-color-scheme: dark)').matches;
        const initialTheme = userPrefersDark ? 'dark' : 'light';
        if (safeDocument) {
            safeDocument.documentElement.classList.toggle('awsui-polaris-dark-mode', initialTheme === 'dark');
        }
        return initialTheme;
    });

    const setThemePreference = useCallback((theme: 'light' | 'dark') => {
        setCurrentTheme(theme);
        if (safeDocument) {
            if (theme === 'dark') {
                safeDocument.documentElement.classList.add('awsui-polaris-dark-mode');
            } else {
                safeDocument.documentElement.classList.remove('awsui-polaris-dark-mode');
            }
        }
    }, []);

    const toggleThemePreference = useCallback(() => {
        setCurrentTheme(prevTheme => {
            const newTheme = prevTheme === 'dark' ? 'light' : 'dark';
            if (safeDocument) {
                safeDocument.documentElement.classList.toggle('awsui-polaris-dark-mode', newTheme === 'dark');
            }
            return newTheme;
        });
    }, []);

    useEffect(() => {
        if (safeWindow) {
            const mediaQuery = safeWindow.matchMedia('(prefers-color-scheme: dark)');
            const handleChange = (e: MediaQueryListEvent) => {
                setThemePreference(e.matches ? 'dark' : 'light');
            };
            mediaQuery.addEventListener('change', handleChange);
            return () => {
                mediaQuery.removeEventListener('change', handleChange);
            };
        }
    }, [setThemePreference]);

    return { currentTheme, toggleThemePreference, setThemePreference };
};

export default ThemePreference;
